import Avatar from '@mui/material/Avatar';
import clsx from 'clsx';
import PersonIcon from '@mui/icons-material/Person';
import IconButton from '@mui/material/IconButton';
import { useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { useConfig } from '../../../config';
import { getUserAvatar } from '../../../utils/Users';
import { fromAuth } from '../../../store';
import CurrentUserInfo from './CurrentUserInfo';

const useStyles = makeStyles(theme => ({
  userAvatar: {
    height: 42,
    width: 42,
    margin: theme.spacing(1),
  },
}));

interface UserInfoBoxProps {
  open: boolean;
  expanded: boolean;
  handleExpand: () => void;
}

const UserInfoBox = ({ open, expanded, handleExpand } : UserInfoBoxProps) => {
  const classes = useStyles();
  const { config } = useConfig();
  const user = useSelector(fromAuth.selectUser);

  return open
    ? <CurrentUserInfo open={open} expanded={expanded} handleExpand={handleExpand} />
    : (
      <Box display="flex" justifyContent="center" alignItems="center">
        <IconButton
          onClick={handleExpand}
          sx={{
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <Avatar
            id="sidebar-user-avatar"
            src={getUserAvatar(user?.avatar, config?.publicUrl)}
            className={clsx(
              classes.userAvatar,
              { [classes.userAvatar]: open },
            )}
          >
            <PersonIcon />
          </Avatar>
        </IconButton>
      </Box>
    );
};

export default UserInfoBox;
